import {AddSchema} from "mobx-graphlink";
import {TriggerSet} from "../@TriggerSet.js";
import {EngineConfig_LightAlarm, EngineConfig_ScriptAlarm, EngineConfig_ShakeAlarm, EngineConfig_SoundAlarm} from "./Alarms/@EC_BasicAlarms.js";
import {EngineConfig_CountdownAlarm} from "./Alarms/@EC_CountdownAlarm.js";
import {AlarmSequence} from "./Alarms/@AlarmConfig.js";
import {Phase} from "../../@Shared/Phase.js";

export type EngineConfig_XAlarm = EngineConfig_SoundAlarm | EngineConfig_CountdownAlarm | EngineConfig_LightAlarm | EngineConfig_ShakeAlarm | EngineConfig_ScriptAlarm;
export const EngineConfig_XAlarm_schema = {anyOf: [
	{$ref: "EngineConfig_SoundAlarm"},
	{$ref: "EngineConfig_CountdownAlarm"},
	{$ref: "EngineConfig_LightAlarm"},
	{$ref: "EngineConfig_ShakeAlarm"},
	{$ref: "EngineConfig_ScriptAlarm"},
]};

export class EngineConfig_Alarms {
	constructor(data: Partial<EngineConfig_Alarms>) { Object.assign(this, data); }

	enabled: boolean;

	// general
	/*snooze_triggerSet: TriggerSet;
	microSnooze_triggerSet: TriggerSet;*/
	voiceSoundTag: string;
	volumeMultiplier: number;

	// signal awakeness
	signalAwakeness_triggerSet: TriggerSet;
	signalAwakeness_solveProgress: boolean;

	// phase: drifting
	phaseSleep_soundTag: string;
	phaseSleep_lightTag: string;
	// may add other on-start effect-types later
	// function: switch phase drifting -> dreaming after delay
	drift_alarmAfterDelay_enabled: boolean;
	alarmDelay_pool: number[]; // in minutes
	alarmDelay_poolRates: {[key: string]: number};
	alarmDelay_lockPerSession: boolean;
	alarmDelay_optionCatchUpRate: number;

	// phase: dreaming
	phaseAlarm_sequences: AlarmSequence[];
	phaseAlarm_sequences_lockPerSession: boolean;

	// phase: solving
	phaseSolving_soundTag: string;
	phaseSolving_lightTag: string;
	solveSuccess_message: string;
	solveSuccess_soundPath: string;
	solveSuccess_soundVolume: number;
	phaseAfterSolveFail: Phase;
}
AddSchema("EngineConfig_Alarms", {
	properties: {
		enabled: {type: "boolean"},
		/*snooze_triggerSet: {$ref: "TriggerSet"},
		microSnooze_triggerSet: {$ref: "TriggerSet"},*/
		voiceSoundTag: {type: "string"},
		volumeMultiplier: {type: "number"},

		signalAwakeness_triggerSet: {$ref: "TriggerSet"},
		signalAwakeness_solveProgress: {type: "boolean"},

		phaseSleep_soundTag: {type: "string"},
		phaseSleep_lightTag: {type: "string"},

		drift_alarmAfterDelay_enabled: {type: "boolean"},
		alarmDelay_pool: {items: {type: "number"}},
		alarmDelay_poolRates: {patternProperties: {"^[0-9]+$": {type: "number"}}},
		alarmDelay_lockPerSession: {type: "boolean"},
		alarmDelay_optionCatchUpRate: {type: "number"},
		phaseAlarm_sequences: {items: {$ref: "AlarmSequence"}},
		phaseAlarm_sequences_lockPerSession: {type: "boolean"},

		phaseSolving_soundTag: {type: "string"},
		phaseSolving_lightTag: {type: "string"},
		solveSuccess_message: {type: "string"},
		solveSuccess_soundPath: {type: "string"},
		solveSuccess_soundVolume: {type: "number"},
		phaseAfterSolveFail: {$ref: "Phase"},
	},
});